'use strict';

var pushProductClick = function (target) {
    var product = $(target).closest('.item-addToCart');
    var listName = product.closest("[data-list-name]").data('list-name');
    pushAndSaveProductClick(product, listName);
    const dhPromise = logDHProductClick(product);
    const criteoPromise = CriteoProductTracker.sendOnClickEvent(product.data('criteo-on-click-beacon'));
    return $.when(dhPromise, criteoPromise);
};

var pushAndSaveProductClick = function (product, listName) {
    // Save the dataLayer's Select_item event in the session storage, to track the Product-list-name after page reload
    const PRODUCT_LIST_MAX_SIZE = 10;
    var productId = product.data('product-code');
    var productListName = product.data('product-list-name') ? product.data('product-list-name') : listName;
    var storageProductsListName = sessionStorage.getItem('productsListName');

    if (listName === 'cartList' && productListName === 'reorder') {
        listName = productListName;
    }

    push_product_click_metrics(product, listName);

    if (storageProductsListName != null) {
        var productsListName = JSON.parse(storageProductsListName);
        if (productsListName.length === PRODUCT_LIST_MAX_SIZE) {
            productsListName.shift();
        }
    } else {
        var productsListName = [];
    }

    productsListName.push({productId, productListName});
    sessionStorage.setItem('productsListName', JSON.stringify(productsListName));
}

var logDHProductClick = function (product) {
    var sku = product.data('product-code'),
        shopTrackingToken = product.data('shop-tracking-token'),
        shopTrackingWebPage = product.data('shop-tracking-web-page');
    var data = {
        sku: sku,
        shopTrackingToken: shopTrackingToken,
        shopTrackingWebPage: shopTrackingWebPage
    };
    if (typeof shopTrackingToken != 'undefined' && typeof shopTrackingWebPage != 'undefined') {
        return $.ajax({
            url: '/trackClick',
            type: 'POST',
            headers: {
                'Accept-Language': window['acceptLanguage']
            },
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.log("logDHProductClick error");
                }
            }
        });
    } else {
        return $().promise();
    }
};

$(document).on('click', 'a.product-details-link', function (event) {
    event.preventDefault();
    const target = this;
    const promise = pushProductClick(this);
    promise.always(function () {
        window.location.href = target.href;
    });
});

$(function () {
    $('.item-addToCart').each(function (index, element) {
        const $element = $(element);
        const formatLevelOnLoadBeacon = $element.data('criteo-format-level-on-load-beacon');
        const formatLevelOnViewBeacon = $element.data('criteo-format-level-on-view-beacon');
        const criteoProductTracker = new CriteoProductTracker(formatLevelOnLoadBeacon, formatLevelOnViewBeacon);
        criteoProductTracker.sendOnLoadEvent($element.data('criteo-on-load-beacon'));
        criteoProductTracker.registerOnViewEvent($element, $element.data('criteo-on-view-beacon'));
    });
});